import { render, staticRenderFns } from "./list-menu-lote.vue?vue&type=template&id=2f357fd7"
import script from "./list-menu-lote.vue?vue&type=script&lang=js"
export * from "./list-menu-lote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports